import { render, staticRenderFns } from "./fromMoveNow.vue?vue&type=template&id=71f115b3&scoped=true"
import script from "./fromMoveNow.vue?vue&type=script&lang=js"
export * from "./fromMoveNow.vue?vue&type=script&lang=js"
import style0 from "./fromMoveNow.vue?vue&type=style&index=0&id=71f115b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f115b3",
  null
  
)

export default component.exports